import { FeatureFlagIds } from "../../../../utils/featureFlagIds";
import React from 'react'
import numeral from 'numeral';
import "./PrintableQuote.css";
import { Theme, createStyles } from '@mui/material/styles';
import { IApplication } from '../../../../Interfaces/Application/IApplication';
import { IQuotePaymentInfo } from '../../../../Interfaces/Common/IQuotePaymentInfo';
import { IQuote } from '../../../../Interfaces/Common/IQuote';
import {IConfiguration} from "../../../../Data/ConfigurationData";
import { AppState } from '../../../../store/rootReducer';
import { useSelector } from 'react-redux';
import { Constants } from '../../../../utils/constants';
import {Organization} from "@amsanalytics/react-shared-library/build/Models/Organization";
import styles from './_printable-quote.module.scss';
// const useStyles: any = makeStyles((theme: Theme) =>
//   createStyles({
//     root: {
//       maxWidth: 900,
//       backgroundColor: 'blue'
//     },
//     container: {
//       fontFamily: 'Arial, Helvetica, sans-serif',
//       fontSize: 12
//     },
//     layout: {
//       maxWidth: 900
//     },
//     smaller: {
//       fontSize: "smaller"
//     },
//     px5: {
//       paddingLeft: 5,
//       paddingRight: 5
//     },
//     pt10: {
//       paddingTop: 10
//     },
//     alignCenter: {
//       textAlign: "center"
//     },
//     alignRight: {
//       textAlign: "right"
//     },
//     vaCenter: {
//       verticalAlign: "middle !important"
//     },
//     totalPrice: {
//       fontSize: 20,
//       fontWeight: "bold"
//     },
//     borderBottom: {
//       " & td": {
//         borderBottom: "1px solid black !important"
//       }
//     },
//     note: {
//       fontSize: 14,
//       lineHeight: 20
//     },

//     quote: {
//       "& .align-center":
//       {
//         textAlign: "center"
//       },
//       "& .align-right":
//       {
//         textAlign: "right"
//       },
//       "& .va-center":
//       {
//         verticalAlign: "middle !important"
//       },

//       "& p": {
//         padding: "0 5px",
//         marginTop: 0,
//         marginBottom: 0,
//         fontSize: "smaller"
//       },
//       "& table": {
//         borderSpacing: 0,
//         width: "100%"
//       },
//       "& th": {
//         borderBottom: "1px solid darkgrey",
//         borderLeft: "1px solid darkgrey",
//         verticalAlign: "top",
//         padding: "2px 3px"
//       },
//       "& td.inner-table": {
//         padding: 0,
//       },
//       "& td": {
//         borderBottom: "1px solid darkgrey",
//         borderLeft: "1px solid darkgrey",
//         verticalAlign: "top",
//         padding: "2px 3px"
//       },
//       "& tbody tr:first-child td": {
//         borderTop: "1px solid darkgrey"
//       },
//       "& tbody tr:first-child td:last-child": {
//         borderTop: "1px solid darkgrey"
//       },
//       "& tbody tr td:last-child": {
//         borderRight: "1px solid darkgrey"
//       },
//       "& .border-right td": {
//         borderRight: "1px solid darkgrey !important",
//         borderSpacing: -1
//       },
//       "& tr.noborder td": {
//         border: "none"
//       },
//       "& tr.border-right td": {
//         borderRight: "1px solid darkgrey !important",
//         borderSpacing: -1,
//       },
//       "& .border-right td:last-child":
//       {
//         borderRight: "0 !important"
//       },

//       "& tbody tr.noborder td:last-child": {
//         border: "none"
//       },
//       "& tbody tr.noborder:first-child td": {
//         border: "none"
//       },
//       "& .thick tr.noborder td": {
//         border: "none"
//       },

//       "& .thick.top tr.noborder td": {
//         border: "none"
//       },

//       "& .thick tbody tr.noborder td:last-child": {
//         border: "none"
//       },
//       "& .thick tbody tr.noborder:first-child td": {
//         border: "none"
//       },
//       "& tr.thick th": {
//         borderBottom: "2px solid black",
//         borderLeft: "2px solid black",
//         verticalAlign: "top",
//         padding: "2px 4px"
//       },
//       "& tr.thick td": {
//         borderBottom: "2px solid black",
//         borderLeft: "2px solid black",
//         verticalAlign: "top",
//         padding: "2px 4px"
//       },
//       "& tbody tr.thick.top td": {
//         borderTop: "2px solid black"
//       },
//       "& tbody tr.thick td:last-child": {
//         borderRight: "2px solid black"
//       },

//       "& strong": {
//         marginRight: 2
//       },
//       "& hr": {
//         border: "0.5px solid black",
//         margin: 0
//       },
//       "& h4": {
//         margin: 0,
//         fontSize: "larger"
//       },
//       "& .thick h4": {
//         margin: "0 0 10px 0"
//       }
//     }
//   }),
// );

interface IPrintableQuoteProps {
  app: IApplication;
  paymentInfo?: IQuotePaymentInfo;
  quote: IQuote;
  PriceDataOnly: boolean;
  configuration:  IConfiguration | undefined;
}

const PrintableQuote: React.FC<IPrintableQuoteProps> = (props) => {
  const { app, paymentInfo, quote } = props;

  const organizations: Organization[] = useSelector((state: AppState) => state.applications.lookups.organizations);
  const currentApp: IApplication | null | undefined = useSelector((state: AppState) => state.applications.editingApp);
  const employees = useSelector((state: AppState) => state.applications.employees); 
  const assignedDealerId = currentApp?.applicationAssignments.find(aa => aa.assignmentEmployeeRoleId === Constants.roles.salespersonId)?.assignedToId ?? null;
  const assignedDealer = employees.find(e => e.id === assignedDealerId) ?? null;
  const assignedSalesManagerId = currentApp?.applicationAssignments.find(aa => aa.assignmentEmployeeRoleId === Constants.roles.salesManagerId)?.assignedToId ?? null;
  const assignedSalesManager = employees.find(e => e.id === assignedSalesManagerId) ?? null;
  const organization = organizations.find(s => s.id === currentApp?.organizationId)?.name ?? null;
  const primary = app.appCustomers.find(x => x.customerRole.isPrimaryApplicant);
  const secondary = app.appCustomers.find(x => !x.customerRole.isPrimaryApplicant);
  const primaryPhone = primary ? primary.customer.customerPhone.find(x => x.isPreferred) : null;
  const primaryAddr = primary ? primary.customer.customerAddress.find(x => x.default) : null;
  const secondaryPhone = secondary ? secondary.customer.customerPhone.find(x => x.isPreferred) : null;

  const initialInvestment: number = ((quote.cashDown ?? 0) + (quote.tradeAllowance ?? 0));
  const paymentRange: string = `$${numeral(((paymentInfo?.monthlyPayment ?? 0) - 10)).format("0,00.00")} - $${numeral(((paymentInfo?.monthlyPayment ?? 0) + 10)).format("0,00.00")} for ${quote.term} months`;
  const vehiclePrice: number = ((quote.carSalePrice ?? 0) > 0 ? quote.carSalePrice! : (app.vehicle ? app.vehicle.carPrice : 0));
  const yourPrice: number = vehiclePrice - (quote.discount ?? 0);
  //const pricePlusFeesAndTaxes = yourPrice + (quote.fees ?? 0) + (quote.taxes ?? 0);
  
  const showOrHideSensitiveInfo = (value: string | Date | null): string => {
    return props.configuration?.featureFlags[FeatureFlagIds.HideSensitiveInfoOnDeskingSheet]
      ? ''
      : value ? value.toString() : '';
  }
  return (
    <div className={styles.printableQuote}>
      {props.app && props.paymentInfo && props.quote && primary ?
        <div className={styles.container}>
          <div className={styles.layout}>
            <div className={styles.quote}>
              <table>
                <tbody>
                  {!props.PriceDataOnly ?
                    (<><tr>
                      <td style={{ width: "25%" }}><strong>Deal #:</strong>{app.applicationNo}</td>
                      <td style={{ width: "25%" }}><strong>License #:</strong></td>
                      <td style={{ width: "25%" }}><strong>Source:</strong>{organization}</td>
                      <td style={{ width: "25%" }}><strong>{new Date(app.createdDate).toDateString()}</strong></td>
                    </tr>
                      <tr>
                        <td><strong>Agent:</strong>{assignedDealer ? assignedDealer.firstName + " " + assignedDealer.lastName : ''}</td>
                        <td className="inner-table" >
                          <table style={{ width: '98%' }}>
                            <tbody>
                              <tr className="noborder">
                                <td style={{ width: "32%" }}><strong>State:</strong>{primary.customer.dlstate?.abbreviation}</td>
                                <td style={{ width: "68%" }}><strong>EXP Date:</strong>N/A</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td colSpan={2}><strong>Desk Manager:</strong>{assignedSalesManager ? assignedSalesManager.firstName + " " + assignedSalesManager.lastName : ''}</td>
                      </tr>
                      <tr>
                        <td><strong>Purchaser:</strong>{primary.customer.firstName} {primary.customer.lastName}</td>
                        <td><strong>SSN:</strong>{showOrHideSensitiveInfo(primary.customer.ssn)}</td>
                        <td><strong>Co-purchaser:</strong>{secondary ? secondary.customer.firstName + " " + secondary.customer.lastName : null}</td>
                        <td><strong>SSN:</strong>{showOrHideSensitiveInfo(secondary ? secondary.customer.ssn : null)}</td>
                      </tr>
                      <tr>
                        <td><strong>DOB:</strong>{showOrHideSensitiveInfo(new Date(primary.customer.dateOfBirth).toLocaleDateString())}</td>
                        <td><strong>Phone:</strong>{primaryPhone ? primaryPhone.phoneNumber : null}</td>
                        <td><strong>DOB:</strong>{showOrHideSensitiveInfo(secondary ? new Date(secondary.customer.dateOfBirth).toLocaleDateString() : null)}</td>
                        <td><strong>Phone:</strong>{secondaryPhone ? secondaryPhone.phoneNumber : null}</td>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          <strong>Address:</strong>{primaryAddr ? `${primaryAddr.street1} ${primaryAddr.street2}` : null}
                        </td>
                        <td colSpan={2}>
                          <strong>City/State/Zip:</strong>{primaryAddr ? `${primaryAddr.city}, ${primaryAddr.state?.abbreviation} ${primaryAddr.zipCode}` : null}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={4}> &nbsp;</td>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          <h4>Purchase Vehicle</h4>
                        </td>
                        <td colSpan={2}>
                          <h4>Trade Vehicle</h4>
                        </td>
                      </tr>
                      <tr>
                        <td><strong>Stock #</strong>{app.vehicle?.stockNumber}</td>
                        <td><strong>Year:</strong>{app.vehicle?.year}</td>
                        <td className="inner-table" colSpan={2}>
                          <table>
                            <tbody>
                              <tr className="noborder border-right">
                                <td style={{ width: "33%" }}><strong>Color:</strong></td>
                                <td style={{ width: "33%" }}><strong>Make:</strong></td>
                                <td style={{ width: "33%" }}><strong>Model:</strong></td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td><strong>Color: </strong>{app.vehicle?.color}</td>
                        <td><strong>Make: </strong>{app.vehicle?.make}</td>
                        <td className="inner-table" colSpan={2}>
                          <table>
                            <tbody>
                              <tr className="noborder border-right">
                                <td style={{ width: "33%" }}><strong>Body:</strong></td>
                                <td style={{ width: "33%" }}><strong>Mlg:</strong></td>
                                <td style={{ width: "33%" }}><strong>Pmts:</strong></td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td><strong>Mileage:</strong>{app.vehicle?.mileage}</td>
                        <td><strong>Model:</strong>{app.vehicle?.model}</td>
                        <td><strong>Payoff:</strong></td>
                        <td><strong>Payoff To:</strong></td>
                      </tr>
                      <tr>
                        <td colSpan={2}></td>
                        <td><strong>Acct #</strong></td>
                        <td><strong>Ver. By</strong></td>
                      </tr>
                      <tr>
                        <td colSpan={2}><strong>VIN # </strong>{app.vehicle?.vin}</td>
                        <td colSpan={2}><strong>VIN #</strong></td>
                      </tr>
                      <tr>
                        <td style={{ marginBottom: 25 }} colSpan={4}></td>
                      </tr>
                    </>) : null}
                  {/* Price starts */}
                  <tr className="thick top">
                    <td style={{ width: "50%" }} colSpan={2}>
                      <h4>Price:</h4>
                      <table style={{ width: "60%" }}>
                        <tbody>
                          <tr className="noborder">
                            <td style={{ whiteSpace: 'nowrap' }}>Vehicle Price:</td>
                            <td className="align-center">$</td>
                            <td className="align-right">{numeral(vehiclePrice).format("0,0.00")}</td>
                          </tr>
                          <tr className="noborder border-bottom">
                            <td>Discount:</td>
                            <td className="align-center">$</td>
                            <td className="align-right">-{quote.discount ?? 0}</td>
                          </tr>
                          <tr className="noborder">
                            <td className="va-center">Your Price:</td>
                            <td className="align-center va-center">$</td>
                            <td className="align-right va-center total-price">{numeral(yourPrice).format("0,0.00")}</td>
                          </tr>
                          <tr className="noborder">
                            <td colSpan={3}>&nbsp;</td>
                          </tr>
                          <tr className="noborder">
                            <td colSpan={3}>(* Amt Financed) = ${numeral(props.quote.amountToFinance).format("0,0.00")}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td colSpan={3}>
                      <h4>Trade Allowance:</h4>
                      <table>
                        <tbody>
                        <tr className="noborder">
                          <td rowSpan={5} style={{ verticalAlign: "middle", paddingBottom: 15 }}>
                            <div style={{ fontSize: 24, fontWeight: "bold" }}>${numeral(props.quote.tradeAllowance).format("0,0.00")}</div>
                            <div style={{ paddingTop: 10 }}></div>
                          </td>
                          <td>&nbsp;</td>
                        </tr>
                        <tr className="noborder">
                          <td>&nbsp;</td>
                        </tr>
                        <tr className="noborder">
                          <td>&nbsp;</td>
                        </tr>
                        <tr className="noborder">
                          <td>&nbsp;</td>
                        </tr>
                        <tr className="noborder">
                          <td>&nbsp;</td>
                        </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr className="thick">
                    <td colSpan={2}>
                      <h4>Initial Investment:</h4>
                      <table>
                        <tbody>
                          <tr className="noborder">
                            <td rowSpan={4} style={{ verticalAlign: "middle", paddingBottom: 15 }}>
                              <div style={{ fontSize: 24, fontWeight: "bold" }}>${numeral(initialInvestment).format("0,0.00")}</div>
                            </td>
                            <td>&nbsp;</td>
                          </tr>
                          <tr className="noborder">
                            <td>&nbsp;</td>
                          </tr>
                          <tr className="noborder">
                            <td>&nbsp;</td>
                          </tr>
                          <tr className="noborder">
                            <td>&nbsp;</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td colSpan={2}>
                      <h4>Monthly Budget:</h4>
                      <table>
                        <tbody>
                          <tr className="noborder">
                            <td rowSpan={4} style={{ verticalAlign: "middle", paddingBottom: 15 }}>
                              <div style={{ fontSize: 24, fontWeight: "bold" }}>{paymentRange}</div>
                            </td>
                            <td>&nbsp;</td>
                          </tr>
                          <tr className="noborder">
                            <td>&nbsp;</td>
                          </tr>
                          <tr className="noborder">
                            <td>&nbsp;</td>
                          </tr>
                          <tr className="noborder">
                            <td>&nbsp;</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
              {!props.PriceDataOnly ?
                <div style={{ marginTop: 10 }}>
                  <h3>Quoter Page Inputs</h3>
                  <table>
                    <tbody>
                      <tr className="noborder">
                        <td><strong>Interest Rate:</strong></td>
                        <td>{props.quote.apr}</td>
                        <td><strong>Tax %:</strong></td>
                        <td>{props.quote.taxes}</td>
                      </tr>
                      <tr className="noborder">
                        <td><strong>Number of Payments:</strong></td>
                        <td>{props.paymentInfo.numberOfPayments}</td>
                        <td><strong>Total Fees:</strong></td>
                        <td>{props.quote.fees}</td>
                      </tr>
                      <tr className="noborder">
                        <td><strong>Selling Price:</strong></td>
                        <td>{props.quote.carSalePrice}</td>
                        <td><strong>Misc:</strong></td>
                        <td>{props.quote.other}</td>
                      </tr>
                      <tr className="noborder">
                        <td><strong>Trade Allowance:</strong></td>
                        <td>{props.quote.tradeAllowance}</td>
                        <td><strong>Pay Type:</strong></td>
                        <td>{props.quote.quotePayType?.name}</td>
                      </tr>
                      <tr className="noborder">
                        <td><strong>Trade Lien:</strong></td>
                        <td>{props.quote.tradeLien}</td>
                        <td><strong>Payment:</strong></td>
                        <td>${numeral(props.paymentInfo.payment).format("0,0.00")}</td>
                      </tr>
                      <tr className="noborder">
                        <td><strong>Cash Down:</strong></td>
                        <td>{props.quote.cashDown}</td>
                        <td><strong>Term:</strong></td>
                        <td>{props.quote.term}</td>
                      </tr>
                      <tr className="noborder">
                        <td><strong>Deferred Down:</strong></td>
                        <td>{props.quote.deferredDown}</td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div> : null}
            </div>
          </div>
        </div> : null}
    </div>)
}

export default PrintableQuote;
